import { render, staticRenderFns } from "./StripeCardIndex.vue?vue&type=template&id=890c12b6"
import script from "./StripeCardIndex.vue?vue&type=script&lang=js"
export * from "./StripeCardIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports